import React, { useRef, useState, useEffect, useContext } from 'react'
import axios from '../../../../config/axios'
import { Container, OptionDiv, OptionText } from './style'
import UserContext from '../../../../contexts/UserContext'
import StockContext from '../../../../contexts/StockContext'
import ApiService from '../../../../services/ApiService'

interface StockDropdwonMenu {
  text: string
  field: string
  onChange: (value: string) => void
  openUpward?: boolean
}

const StockDropdown: React.FC<StockDropdwonMenu> = (props) => {
  const { token, user } = useContext(UserContext)
  const { stock, setStock } = useContext(StockContext)
  const [options, setOptions] = useState<string[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    if (!token || !props.field) return;

    setLoading(true)
    setError(false)

    const controller = new AbortController()

    if (props.field === 'heatNumber') {
      axios
        .get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/heat-number`, {
          headers: { Authorization: `Bearer ${token}` },
          signal: controller.signal,
          timeout: 10000,
        })
        .then((response) => {
          const data = Array.isArray(response.data) ? response.data : []
          setOptions(data)
          setError(false)
        })
        .catch((error) => {
          if (error.name !== 'CanceledError') {
            setOptions([])
            setError(true)
          }
        })
        .finally(() => setLoading(false))
      return () => controller.abort()
    }

    if (props.field === 'supplier') {
      ApiService.companies.findAll({
        query: props.text,
        companyType: 2,
        excludeMainCompany: 'true'
      })
        .then((response: any) => {
          const companies = Array.isArray(response.data) ? response.data : []
          const supplierNames = companies.map((c: any) => c.companyName).filter((name: string) => name)
          setOptions(supplierNames)
          setError(false)
        })
        .catch((error) => {
          if (error.name !== 'CanceledError') {
            setOptions([])
            setError(true)
          }
        })
        .finally(() => {
          setLoading(false)
        })

      return () => {
        controller.abort()
      }
    }

    let endpoint = ''
    if (props.field === 'density') {
      endpoint = `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/material/${props.field}`
    } else if (props.field === 'material') {
      endpoint = `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/material/stock`
    } else {
      endpoint = `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/${props.field}`
    }

    axios
      .get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal: controller.signal,
        timeout: 10000,
      })
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : []
        setOptions(data)
        setError(false)
      })
      .catch((error) => {
        if (error.name !== 'CanceledError') {
          setOptions([])
          setError(true)
        }
      })
      .finally(() => {
        setLoading(false)
      })

    return () => {
      controller.abort()
    }
  }, [token, props.field, props.text])

  let filteredOptions = Array.isArray(options) ? options : []
  filteredOptions = filteredOptions.filter(
    (value) => value !== null && value !== '',
  )

  if (props.field !== 'format' && props.text !== '' && props.text !== null) {
    filteredOptions = filteredOptions.filter((str) =>
      str.toLowerCase().includes(props.text.toLowerCase()),
    )
  }

  if (loading) {
    return (
      <Container $openUpward={props.openUpward} className="loading">
        <OptionText>Carregando...</OptionText>
      </Container>
    )
  }

  if (error) {
    return (
      <Container $openUpward={props.openUpward} className="error">
        <OptionText>Erro ao carregar dados</OptionText>
      </Container>
    )
  }

  return (
    <Container
      $openUpward={props.openUpward}
      onMouseDown={(e) => e.preventDefault()}
      className={filteredOptions.length == 0 ? 'empty' : ''}
    >
      {filteredOptions.map((header, index) => (
        <OptionDiv key={index} onClick={() => props.onChange(header)}>
          <OptionText>{header}</OptionText>
        </OptionDiv>
      ))}
    </Container>
  )
}

export default StockDropdown

